import React, { useState, useEffect } from "react";
import API from "../../../services/api";

const InactivitySlider = ({ onClose }) => {
    const [images, setImages] = useState([]);
    const [index, setIndex] = useState(0);

    const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

    const getImageUrl = (imgPath) => `${BASE_URL}/storage/${imgPath}`;

    // Fetch last 10 slider images
    useEffect(() => {
        const fetchImages = async () => {
            try {
                const res = await API.get("slider/latest");
                setImages(res.data || []);
            } catch (err) {
                console.error("Failed to load slider images:", err);
            }
        };
        fetchImages();
    }, []);

    // Auto-slide every 3 seconds
    useEffect(() => {
        if (images.length === 0) return;

        const timer = setInterval(() => {
            setIndex((prev) => (prev + 1) % images.length);
        }, 15000);

        return () => clearInterval(timer);
    }, [images]);

    if (images.length === 0) return null;

    return (
        <div
            style={{
                width: "100vw",
                height: "100vh",
                position: "fixed",
                top: 0,
                left: 0,
                zIndex: 9999,
                backgroundColor: "black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
                cursor: "pointer",
            }}
            onClick={onClose}
        >
            {images.map((img, i) => (
                <img
                    key={i}
                    src={getImageUrl(img.image)}
                    alt={`slide-${i}`}
                    style={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        opacity: i === index ? 1 : 0,
                        transition: "opacity 1s ease-in-out",
                        zIndex: i === index ? 1 : 0,
                    }}
                />
            ))}
        </div>
    );
};

export default InactivitySlider;
